export interface UseGoogleMapsKeyResult {
  hasKey: boolean;
  apiKey: string | null;
}

/**
 * Detecção runtime de `REACT_APP_GOOGLE_MAPS_API_KEY` (convenção CRA — só
 * variáveis prefixadas com REACT_APP_ são embutidas no bundle). `hasKey` é
 * `true` somente quando a variável existe e não é uma string vazia/whitespace
 * (plano google-maps-localizacao-phase-2-frontend-fundao-de-mapa, Task 4).
 * A leitura acontece a cada chamada (corpo da função), não em escopo de
 * módulo, para refletir o valor atual de `process.env` a cada chamada.
 *
 * Deliberadamente sem `useState`/`useMemo`/`useEffect`: não há estado local
 * nem efeito colateral a orquestrar — apenas uma leitura síncrona e pura de
 * `process.env`, então nenhum hook do React é necessário aqui (o nome
 * `useGoogleMapsKey` segue a convenção de nomenclatura de hooks por
 * consistência de camada, não por uso de hooks internos do React).
 */
export function useGoogleMapsKey(): UseGoogleMapsKeyResult {
  const raw = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const trimmed = (raw ?? '').trim();
  const hasKey = trimmed.length > 0;
  return { hasKey, apiKey: hasKey ? (raw as string) : null };
}
